module.exports = __webpack_public_path__ + "static/media/SonyPictures.ef8b6d12.png";